// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__l2oNM","rotation":"loading_rotation__OcnEq"};